import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import controller from './document-association-dialog.controller';
import template from './document-association-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    folderId = null,
    documentId = null,
    serviceId = null,
    service = null,
    associations = null,
    document = null,
    parentFolder = null,
    acceptCallback = null,
    declineCallback = null
  }) {
    return {
      controller,
      controllerAs: 'documentAssociationDialogVM',
      locals: {
        folderId,
        documentId,
        serviceId,
        service,
        associations,
        document,
        parentFolder,
        acceptCallback,
        declineCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.documentManagement.documentAssociationDialog', [
  ssDialogService,
  loaderService,
  alerts,
  docDataService,
])
  .service('documentAssociationDialog', dialogService)
  // .run(($templateCache) => {
  // $templateCache.put('messages.required.html', messagesTpl);
  // })
  .name;

console.log('app.components.global.documentManagement.documentAssociationDialog created');
